import Route from '@ember/routing/route';

export default class QuickPaymentRoute extends Route {}
